import { render, staticRenderFns } from "./BureausPage.vue?vue&type=template&id=4698a9fa&scoped=true"
import script from "./BureausPage.vue?vue&type=script&lang=ts"
export * from "./BureausPage.vue?vue&type=script&lang=ts"
import style0 from "./BureausPage.vue?vue&type=style&index=0&id=4698a9fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4698a9fa",
  null
  
)

export default component.exports